export default __webpack_public_path__ + "static/media/image-7.ed6191ed.jpg";